import classNames from "classnames";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  isOverflow?: boolean;
};

export const Card = ({ children, isOverflow = false }: Props) => {
  const c = ["bg-white-100", "rounded-md", "min-h-full", "w-full", "shadow-2xs"];
  if (isOverflow) {
    c.push("overflow-visible");
  }
  return <div className={classNames(c)}>{children}</div>;
};
